import { HOTEL_SEARCH_FETCHED } from '../../actions/hotel';

export default function totalResultsBySearchId(state = {}, action) {
  const newState = Object.assign({}, state);

  switch (action.type) {
    case HOTEL_SEARCH_FETCHED:
      newState[action.searchId] = action.availableResults;
      return newState;

    default:
      return state;
  }
}
